<template>
  <smart-banner
    v-if="!hasConflict"
    :class="classes"
    :bg-color="validateBgColor"
    :direction="direction"
    :has-kicker="false"
    title-color="#233037"
    title-size="h2"
    title-weight="400"
    title-align="left"
    text-color="#43515A"
    text-size="xs"
    text-weight="400"
    text-align="left"
    :has-button="false"
    :has-image="hasImage"
    :image-mobile="imageMobile"
    :image-tablet="imageTablet"
    :image-desktop="imageDesktop"
    :alt="alt"
    :center-items="false"
    :reduce-width="false"
    :has-video="hasVideo"
  >
    <template #video>
      <slot name="quinary-video" />
    </template>
    <template #breadcrumb>
      <slot name="quinary-breadcrumb" />
    </template>
    <template #title>
      <slot name="quinary-title" />
    </template>
    <template #text>
      <slot name="quinary-text" />
    </template>
  </smart-banner>
</template>

<script>
import { computed } from 'vue'
import SmartBanner from './smart-banner.vue'

export default {
  name: 'smart-banner-quinary',
  components: {
    SmartBanner,
  },
  props: {
    direction: {
      type: String,
    },
    imageMobile: {
      type: String,
    },
    imageTablet: {
      type: String,
    },
    imageDesktop: {
      type: String,
    },
    alt: {
      type: String,
    },
    bgColor: {
      type: String,
      default: '#EDF2F5',
    },
    hasVideo: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const classes = computed(() => [
      'smart-banner',
      `smart-banner--${props.direction}`,
    ])

    const validateBgColor = computed(() => {
      return props.bgColor === '#EDF2F5' ? '#EDF2F5' : 'transparent'
    })

    const hasImage = computed(() => {
      return Boolean(props.imageMobile || props.imageTablet || props.imageDesktop)
    })

    const hasConflict = computed(() => {
      return props.hasVideo && hasImage.value
    })

    return {
      classes,
      validateBgColor,
      hasImage,
      hasConflict,
    }
  },
}
</script>

<style lang="scss" scoped>
.smart-banner {
  @include direction();
}
</style>
